// src/store/auth.js
import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('auth.token') || '',
    user: (() => {
      try { return JSON.parse(localStorage.getItem('auth.user')) } catch { return null }
    })(),
  }),
  getters: {
    isAuthenticated: (s) => !!s.token,
    roles: (s) => Array.isArray(s.user?.roles) ? s.user.roles : [],
    email: (s) => s.user?.email || null,
  },
  actions: {
    setSession(token, user) {
      try {
        if (token) localStorage.setItem('auth.token', token); else localStorage.removeItem('auth.token');
        if (user) localStorage.setItem('auth.user', JSON.stringify(user)); else localStorage.removeItem('auth.user');
      } catch (e) { void 0; }
      this.token = token || ''
      this.user = user || null
    },
    clearSession() {
      try { localStorage.removeItem('auth.token'); localStorage.removeItem('auth.user'); } catch (e) { void 0; }
      this.token = ''
      this.user = null
    },
    syncFromStorage() {
      try {
        this.token = localStorage.getItem('auth.token') || ''
        const u = localStorage.getItem('auth.user')
        this.user = u ? JSON.parse(u) : null
      } catch { this.token = ''; this.user = null }
    }
  }
})
